
import { fixedNumber, dateUtil } from '../../../util/util';

/**
 * 计算应缴纳的各个税收
 * isSeller 是否旧车主 false：否，true：是
 * type 纳税人类型
 * amout 计算的车价
 */
const calculationTax = (isSeller, type, amount) => {
    let startTime = 1582992000000;  //调整税率开始时间，2020-03-01 00:00:00
    // let endTime = 1590940800000;  //调整税率结束时间，2020-06-01 00:00:00
    let endTime = 1609430400000;  //调整税率结束时间，2021-01-01 00:00:00
    var nowTime = new Date().getTime();     //获取当前时间
    let tax = {};
    if (type === "1" || !isSeller) {
        //个人只收印花税， 车价*0.05%*0.5
        // let stampTax = fixedNumber(amount * 0.0005 * 0.5, 2);
        let stampTax = fixedNumber(amount * 0.0005 * 0.5, 1); //改为只保留一位小数
        if (stampTax < 1) {
            tax.stampTax = 0;
            tax.totalTax = 0;
        } else {
            tax.stampTax = stampTax;
            tax.totalTax = stampTax;
        }
    } else if (type === "2") {
        //个体户
        let value;
        let addedTax;
        if (nowTime > startTime && nowTime < endTime) {
            //计算公式 [ 车价 / (1+1%) * 1% ]
            value = fixedNumber(amount / 1.01, 2);
            addedTax = fixedNumber(value * 0.01, 2);
        }else{
            //计算公式 [ 车价 / (1+3%) * 2% ]
            value = fixedNumber(amount / 1.03, 2);
            addedTax = fixedNumber(value * 0.02, 2);
        }
        tax.addedTaxAmount = value; //增值税计税金额
        tax.addedTax = addedTax;   //增值税
        tax.constructionTax = fixedNumber(addedTax * 0.07 * 0.5, 2);  //城市维护建设税
        tax.educationalSurtax = fixedNumber(addedTax * 0.03 * 0.5, 2);  //教育费附加
        tax.localEducationalSurtax = fixedNumber(addedTax * 0.02 * 0.5, 2);    //地方教育附加
        tax.stampTax = fixedNumber(amount * 0.0005 * 0.5, 2);   //印花税
    } else if (type === "3") {
        //小规模纳税人
        let value = fixedNumber(amount / 1.03, 2);
        let addedTax = fixedNumber(value * 0.02, 2);
        tax.addedTaxAmount = value; //增值税计税金额
        tax.addedTax = addedTax;   //增值税
        tax.constructionTax = fixedNumber(addedTax * 0.07, 2);  //城市维护建设税
        tax.educationalSurtax = fixedNumber(addedTax * 0.03, 2);  //教育费附加
        tax.localEducationalSurtax = fixedNumber(addedTax * 0.02, 2);    //地方教育附加
        tax.stampTax = fixedNumber(amount * 0.0005, 2);   //印花税
    } else if (type === "4") {
        //小规模纳税人-固定资产
        let value = fixedNumber(amount / 1.13, 2);
        let addedTax = fixedNumber(value * 0.13, 2);
        tax.addedTaxAmount = value; //增值税计税金额
        tax.addedTax = addedTax;   //增值税
        tax.constructionTax = fixedNumber(addedTax * 0.07, 2);  //城市维护建设税
        tax.educationalSurtax = fixedNumber(addedTax * 0.03, 2);  //教育费附加
        tax.localEducationalSurtax = fixedNumber(addedTax * 0.02, 2);    //地方教育附加
        tax.stampTax = fixedNumber(amount * 0.0005, 2);   //印花税
    }
    if (type !== "1" && isSeller) {
        tax.totalTax = tax.addedTax + tax.constructionTax + tax.educationalSurtax + tax.localEducationalSurtax + tax.stampTax;
        tax.totalTax = tax.totalTax.toFixed(2);
    }
    return tax;
}

const getTaxTicketItem = (type) => {
    let startTime = 1582992000000;  //调整税率开始时间，2020-03-01 00:00:00
    // let endTime = 1590940800000;  //调整税率结束时间，2020-06-01 00:00:00
    let endTime = 1609430400000;  //调整税率结束时间，2021-01-01 00:00:00
    var nowTime = new Date().getTime();     //获取当前时间
    let taxDuration = dateUtil.getCurrentMonthFirstDay() + "-" + dateUtil.getCurrentMonthLastDay();
    let taxRate = [];
    if (type !== "1") {
        taxRate.push({ taxCategory: "增值税", itemName: "二手车", taxationAmount: "1", taxableAmount: 0, taxRate: "3%", taxDuration: taxDuration, taxAmount: '' });
        taxRate.push({ taxCategory: "城市维护建设税", itemName: "二手车", taxationAmount: "1", taxableAmount: 0, taxRate: "7%", taxDuration: taxDuration, taxAmount: '' });
        taxRate.push({ taxCategory: "教育费附加", itemName: "二手车", taxationAmount: "1", taxableAmount: 0, taxRate: "3%", taxDuration: taxDuration, taxAmount: '' });
        taxRate.push({ taxCategory: "地方教育附加", itemName: "二手车", taxationAmount: "1", taxableAmount: 0, taxRate: "2%", taxDuration: taxDuration, taxAmount: '' });
        //taxRate.push({ "name": "印花税", rate: "0.05%" });
    }
    if (type === "2" && nowTime > startTime && nowTime < endTime) {
        //因为新馆病毒疫情的影响，2020-03-01 到2020-05-31调整小规模纳税人的增值税纳税金额
        taxRate[0].taxRate = "1%";
    }
    taxRate.push({ taxCategory: "印花税", itemName: "二手车", taxationAmount: "1", taxableAmount: 0, taxRate: "0.05%", taxDuration: taxDuration, taxAmount: '' });
    if (type === "4") {
        taxRate[0].taxRate = "13%";
    }
    return taxRate;
}

export { calculationTax, getTaxTicketItem };